<!-- 用户个人中心  -->
<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<!-- 个人信息页面 -->
		<div class="userContent">
			<div class="userInfo mt-3">
				<div>
					<el-tabs :tab-position="tabPosition" style="height:600px;--el-color-primary: #C32A1A;">
						<el-tab-pane label="基本信息">
							<div class="basicInfo">
								<div>
									<span class="title">账户信息</span>
									<p class="pt-4">用户名/手机号码：{{$store.state.user.phone}}</p>
									<p v-show="$store.state.user.name">姓名/称呼：{{$store.state.user.name || '暂未填写'}}</p>
									<p v-show="$store.state.user.sex">性别：{{$store.state.user.sex == '先生' ? '男' : '女'  || '暂未填写'}}</p>
									<p>注册时间：{{$store.state.user.createAt}}</p>
								</div>
								<div>
									<span type="info" @click="logOut" style="color: #C32A1A;cursor: pointer;"
									>退出登录</span>
								</div>
							</div>
							<!-- 联系购买记录 -->
							<div class="wantBuyStatus">
								<span class="title">联系购买记录</span>
								<el-table :data="buyRecordArr" style="width: 100%;" height="280"
								:default-sort="{ prop: 'date', order: 'descending' }">
									<el-table-column prop="createAt" label="日期" sortable />
									<el-table-column prop="goodName" label="名称" width="500"/>
									<el-table-column label="所属类型" align="center">
										<template #default="scope">{{ scope.row.mbxLink == 'patent' ? '专利' : '商标' }}</template>
									</el-table-column>
									<el-table-column label="当前状态">
										<template #default="scope">
											<div>
												{{ scope.row.status}}
											</div>
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template #default="scope">
											<div>
												<el-link type="primary"
												@click="goDetail(scope.row.goodId,scope.row.mbx,scope.row.mbxLink,scope.row.mbxLink)">查看</el-link>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的收藏">
							<div class="wantBuyStatus">
								<span class="title">我的收藏</span>
								<div class="d-flex flex-wrap mt-1" style="height: 545px;overflow: auto;">
									<div class="myCollect mb-4" v-for="(item,index) in collectArr" :key="index"
									style="margin-right:30px;">
										<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :patentType="item.patentType"
										:price="item.chargeAmount" @click="goDetail(item.id,item.pageName,item.url,item.typer)" style="cursor: pointer;"></show-card>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的求购">
							<div class="wantBuyStatus">
								<span class="title">我的求购</span>
								<el-table :data="wantBuyRecord" style="width: 100%"  height="500"
								:default-sort="{ prop: 'date', order: 'descending' }">
									<el-table-column prop="createAt" label="日期" width="180" sortable/>
									<el-table-column prop="name" label="求购信息" width="500"/>
									<el-table-column prop="type" label="求购类型"/>
									<el-table-column prop="status" label="当前状态"/>
									<el-table-column label="操作">
										<template #default="scope">
											<div>
												<el-link type="primary" :disabled="scope.row.status!=='通过'"
												@click="goWantBuyDetail(scope.row.id,scope.row.type,'/purchaseList')">查看</el-link>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
            <el-tab-pane label="专利收藏">
              <div class="wantBuyStatus">
                <span class="title">专利收藏</span>
                <el-button type="primary" style="margin-left: 10px; float: right" @click="createCollectionDialog(1)">新建收藏夹</el-button>
                <div  style="height: 545px;overflow: auto;">
                  <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;" v-for="(item, index) in collectionList">
                    <el-col :span="12" style="align-content: center; text-align: center">
                      <span style="font-size: 16px;">{{item.collectionName}}</span>
                    </el-col>
                    <el-col :span="12" style="">
                      <el-popconfirm title="确定要删除吗？" @confirm="deleteCollection(item.id)">?">
                        <template #reference>
                          <el-button type="danger" style="margin-left: 10px; float: right"  plain>删除</el-button>
                        </template>
                      </el-popconfirm>
                      <el-button type="success" style="float: right"  plain @click="updateCollectionDialog(item)">修改</el-button>
                      <el-button type="primary" style="float: right"  plain @click="getZlList(item.id)">查看</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="期刊收藏">
              <div class="wantBuyStatus">
                <span class="title">期刊收藏</span>
                <el-button type="primary" style="margin-left: 10px; float: right" @click="createCollectionDialog(2)">新建收藏夹</el-button>
                <div  style="height: 545px;overflow: auto;">
                  <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;" v-for="(item, index) in qikanCollectionList">
                    <el-col :span="12" style="align-content: center; text-align: center">
                      <span style="font-size: 16px;">{{item.collectionName}}</span>
                    </el-col>
                    <el-col :span="12" style="">
                      <el-popconfirm title="确定要删除吗？" @confirm="deleteCollection(item.id)">?">
                        <template #reference>
                          <el-button type="danger" style="margin-left: 10px; float: right"  plain>删除</el-button>
                        </template>
                      </el-popconfirm>
                      <el-button type="success" style="float: right"  plain @click="updateCollectionDialog(item)">修改</el-button>
                      <el-button type="primary" style="float: right"  plain @click="getZlList(item.id)">查看</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的订阅">
              <div class="wantBuyStatus">
                <span class="title">我的订阅</span>
                <el-button type="primary" style="margin-left: 10px; float: right" @click="findCollectionDialog">搜索订阅</el-button>
                <div  style="height: 545px;overflow: auto;">
                  <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;" v-for="(item, index) in subscribeList">
                    <el-col :span="12" style="align-content: center; text-align: center">
                      <span style="font-size: 16px;">{{item.collectionName}}</span>
                    </el-col>
                    <el-col :span="12" style="">
                      <el-popconfirm title="确定要取消订阅吗？" @confirm="cancelSubscribe(item.collectionId)">?">
                        <template #reference>
                          <el-button type="danger" style="margin-left: 10px; float: right"  plain>取消订阅</el-button>
                        </template>
                      </el-popconfirm>
                      <el-button type="primary" style="float: right"  plain @click="getZlList(item.collectionId)">查看</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>

    <el-dialog title="查询用户收藏夹" v-model="queryDialogVisible"  width="30%">
      <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;">
        <el-col :span="20" style="align-content: center; text-align: center">
          <el-input v-model="queryUserName"  placeholder="请输入用户名或手机号"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" style="float: right" @click="findCollectionByUserName" plain>查询</el-button>
        </el-col>
      </el-row>
      <div  style="margin-top: 10px; overflow: auto;">
        <el-row v-for="(item, index) in collectionBeSubscribeList" style="border: rgba(216,217,220,0.92) solid 0.5px;" >
          <el-col :span="12" style="align-content: center; text-align: center">
            <span style="font-size: 16px;">{{item.collectionName}}</span>
          </el-col>
          <el-col :span="12" style="">
            <el-button type="primary" style="float: right" @click="addToSubscribe(item.id)" plain>订阅</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="创建收藏夹" v-model="createDialogVisible"  width="30%" >
      <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;">
        <el-col :span="10" style="align-content: center; text-align: center">
          <el-input v-model="createCollectionFrom.collectionName"  placeholder="请输入收藏夹名称"></el-input>
        </el-col>
        <el-col :span="6">
          <el-switch
              v-model="createCollectionFrom.isOpen"
              active-text="公开"
              inactive-text="私密">

          </el-switch>
        </el-col>
        <el-col :span="8" style="">
          <el-button type="primary" style="float: right" @click="createCollection" plain>创建</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="修改收藏夹" v-model="updateDialogVisible"  width="30%" >
      <el-row style="border: rgba(216,217,220,0.92) solid 0.5px;">
        <el-col :span="10" style="align-content: center; text-align: center">
          <el-input v-model="updateCollectionFrom.collectionName"  placeholder="请输入收藏夹名称"></el-input>
        </el-col>
        <el-col :span="6">
          <el-switch
              v-model="updateCollectionFrom.isOpen"
              active-text="公开"
              inactive-text="私密">
          </el-switch>
        </el-col>
        <el-col :span="8" style="">
          <el-button type="primary" style="float: right" @click="updateCollection" plain>修改</el-button>
        </el-col>
      </el-row>
    </el-dialog>
		<!-- 底部导航 -->
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import { ElMessageBox, ElMessage } from 'element-plus'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			Footer
		},
		data() {
			return {
				tabPosition: 'left',
				user:JSON.parse(window.sessionStorage.getItem('user')),
				// 收藏夹
				collectArr:[],
				// 联系购买记录
				buyRecordArr:[],
				// 联系购买表格
				wantBuyRecord:[],
        collectionList: [],
        qikanCollectionList: [],
        queryUserName: '',
        queryDialogVisible: false,
        collectionBeSubscribeList: [],
        //订阅列表
        subscribeList: [],
        createDialogVisible: false,
        updateDialogVisible: false,
        // 创建收藏夹
        createCollectionFrom: {
          userId: null,
          collectionName: '',
          isOpen: 1,
          type: null
        },
        // 更新收藏夹
        updateCollectionFrom: {
          id: null,
          userId: null,
          collectionName: '',
          isOpen: 1,
          type: null
        }
			}
		},
		mounted() {
      this.getCollectionList()
      this.getSubscribeList()
			// 获取联系购买记录
			this.getBuyRecord()

			// 收藏夹
			this.getMycollect()
			this.getWantBuyRecord()
		},
		methods: {
      /* 获取收藏夹列表 */
      getCollectionList() {
        this.axios.get('/api/userCollection/findAllUserCollectList?type=1').then(res => {
          this.collectionList = res.data
        })
        this.axios.get('/api/userCollection/findAllUserCollectList?type=2').then(res => {
          this.qikanCollectionList = res.data
        })
      },
      /* 获取订阅的收藏 */
      getSubscribeList() {
        this.axios.get('/api/userSubscribeCollection/findUserSubscribeCollection').then(res => {
          this.subscribeList = res.data.data
        })
      },
      /* 通过用户手机号或者用户名查询收藏夹 */
      findCollectionByUserName() {
        this.axios.get('/api/userCollection/findUserCollectionByUserName?userName='+this.queryUserName).then(res => {
          this.collectionBeSubscribeList = res.data
        })
      },
      /* 订阅收藏 */
      addToSubscribe(id) {
        this.axios.get('/api/userSubscribeCollection/insertUserSubscribeCollection?collectionId='+id).then(res => {
          if (res.data.code === 10001) {
            this.$message({
              message: '订阅成功',
              type: 'success',
            })
            this.queryDialogVisible = false
            this.getSubscribeList()
          } else {
            this.$message({
              message: '订阅失败',
              type: 'error'
            })
          }
        })
      },
      // 取消订阅
      cancelSubscribe(id) {
        this.axios.get('/api/userSubscribeCollection/cancelUserSubscribeCollection?collectionId='+id).then(res => {
          if (res.data.code === 10001) {
            this.$message({
              message: '取消订阅成功',
              type: 'success'
            })
            this.getSubscribeList()
          } else {
            this.$message({
              message: '取消订阅失败',
              type: 'error'
           })
          }
        })
      },
      getZlList(id) {
        var from = {id: id}
        this.$router.push({
          name: 'zlByCollection',
          params: {
            collectionId: JSON.stringify(from)
          }
        })
      },
      /* 创建收藏夹 */
      createCollection() {
        this.axios.post('/api/userCollection/insertUserCollection', this.createCollectionFrom).then(res => {
          if (res.data.code === 10001) {
            this.getCollectionList()
            this.createDialogVisible = false
            this.$message({
              message: '创建成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '创建失败',
              type: 'error'
            })
          }
        })
      },
      /* 修改收藏夹 */
      updateCollection() {
        this.axios.post('/api/userCollection/updateUserCollection', this.updateCollectionFrom).then(res => {
          if (res.data.code === 10001) {
            this.getCollectionList()
            this.createDialogVisible = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '修改失败',
              type: 'error'
            })
          }
        })
      },
      findCollectionDialog() {
        this.queryDialogVisible = true
      },
      /* 点击创建收藏夹按钮 */
      createCollectionDialog(type) {
        this.createDialogVisible = true
        this.createCollectionFrom.userId = null
        this.createCollectionFrom.collectionName = ''
        this.createCollectionFrom.isOpen = 1
        this.createCollectionFrom.type = type
      },
      /* 点击修改收藏夹按钮 */
      updateCollectionDialog(item) {
        this.updateDialogVisible = true
        this.updateCollectionFrom.id = item.id
        this.updateCollectionFrom.userId = item.userId
        this.updateCollectionFrom.collectionName = item.collectionName
        this.updateCollectionFrom.isOpen = item.isOpen
        this.updateCollectionFrom.type = item.type
      },
      /* 删除收藏夹 */
      deleteCollection(id) {
        this.axios.delete('/api/userCollection/deleteUserCollection?id='+id).then(res => {
          if (res.data.code === 10001) {
            this.getCollectionList()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          }
        })
      },
			// 获取求购记录
			getWantBuyRecord(){
				let vm = this
				this.axios.post('/api/want/buy/findByOneSelf',{type:'',category:'',status:''}).then(res => {
					//type+category 和我要发布获取路径一样
					//status [通过，未通过，审核中]
					this.wantBuyRecord = res.data.data
				})
			},
			// 获取联系购买记录
			getBuyRecord(){
				let vm = this
				this.axios.post('/api/link/buy/findByOneSelf',{mbxLink:''}).then(res => {
					vm.buyRecordArr = res.data.data
				})
			},
			// 收藏夹
			getMycollect(){
				let vm = this
				this.axios.post('/api/collect/findByOneSelf',{mbxLink:""}).then(res => {
					let brandArr = res.data.data.brands
					let patentArr = res.data.data.patents
					brandArr.forEach((item,index,arr)=>{
						// brandArr[index].typer = 'brand'
						// vue.set(brandArr[index],'typer','brand')
						let objBrand = {typer:'brand'}
						brandArr[index] = {...brandArr[index],...objBrand}
					})
					patentArr.forEach((item,index,arr)=>{
						// patentArr[index].typer = 'patent'
						let objPatent= {typer:'patent'}
						patentArr[index] = {...patentArr[index],...objPatent}
					})
					vm.collectArr = [...brandArr,...patentArr]
				})
			},
			// 查看商品
			goDetail(id,mbx,mbxLink,type){
				let vm = this
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:type
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 查看我的求购详情页
			goWantBuyDetail(id,mbx,mbxLink){
				let vm = this
				let routeData = this.$router.resolve({
					path:'/purchaseDetail',
					query:{
						id:id,
						mbx:mbx == '商标' ? '商标求购' : '专利求购',
						mbxLink:mbxLink,
						type:mbx == '商标' ? '商标' : '专利',
					}
				})
				window.open(routeData.href, '_blank');
			},
			logOut() {
				  ElMessageBox.confirm(
				    '您确定要退出登录吗?',
				    '提示',
				    {
				      confirmButtonText: '退出',
				      cancelButtonText: '取消',
				      type: 'warning',
				    }
				  )
				    .then(() => {
					  this.$store.commit('logout')
						this.$router.push('/')
				      ElMessage({
				        type: 'success',
				        message: '您已成功退出登录',
				      })
				    })
				    .catch(() => {
				      ElMessage({
				        type: 'info',
				        message: '取消退出登录操作',
				      })
				    })
			}
		},
	}
</script>

<style scoped>
	.userContent{
		width: 100%;
		min-height:600px;
		background-color: #f8f8f8;
		overflow: hidden;
	}
	.userInfo{
		width: 1200px;
		min-height: 600px;
		background-color: #fff;
		margin: 0 auto;
		margin-bottom: 20px;
	}
	/* 基本信息 */
	.basicInfo{
		width: 100%;
		height:250px;
		border-bottom: 1px solid #eee;
		padding: 20px;
	}
	.basicInfo .title,
	.wantBuyStatus .title{
		font-size: 20px;
		font-weight: bold;
	}
	.wantBuyStatus{
		width: 100%;
		min-height:350px;
		padding: 20px;
	}
</style>
